import Vue from 'vue'
import App from './App.vue'

import Toasted from 'vue-toasted'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCopy } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

Vue.config.productionTip = false

library.add(faCopy)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(Toasted)

new Vue({
  comments: true,
  render: (h) => h(App),
}).$mount('#app')
